"use strict";
/*
 * Created on 10. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Rule for determining price code of product.
 * Based on Table 19 Price list with price codes, rules and priorities (from Blueprint).
 * @author Radek Beran
 */

var PriceCodeRule;

(function (PriceCodeRule) {
  /** Sellout rule: Product is repriced with sellout price for the first time (within one sellout release). */
  PriceCodeRule["FirstPrice"] = "FirstPrice";
  /** Sellout rule: Product is repriced with sellout price for the second, or third, ... time (within one sellout release). */

  PriceCodeRule["SecondPrice"] = "SecondPrice";
  /** It is a new product and first price. */

  PriceCodeRule["NewProductFirstPrice"] = "NewProductFirstPrice";
  /** The final price is 5 % cheaper than last local regular price. */

  PriceCodeRule["FinalPriceCheaperThanRegular"] = "FinalPriceCheaperThanRegular";
  /** Not new product, not first price. */

  PriceCodeRule["OtherRegular"] = "OtherRegular";
})(PriceCodeRule = exports.PriceCodeRule || (exports.PriceCodeRule = {}));